import * as R from "ramda";
import { NO_DISPLAY_ANNOT_TYPE } from "./constants/annotations.mjs";
import { parseNoDisplayAnnotation } from "./parseNoDisplayAnnotation.mjs";
import { getConcepts } from "./getConcepts.mjs";
import { getUrn } from "./getUrn.mjs";
import { getCodeOrder } from "./getCodeOrder.mjs";
const getDisplayValues = ({
  hasNoDisplayAnnotation,
  artefactId,
  noDisplayCodes,
  code
}) => R.allPass([
  R.complement(hasNoDisplayAnnotation),
  R.pipe(
    R.prop("id"),
    R.flip(R.append)([artefactId, "values"]),
    R.flip(R.complement(R.hasPath))(noDisplayCodes)
  )
])(code);
const getDisplay = ({
  hasNoDisplayAnnotation,
  codelist,
  artefact,
  artefactId,
  noDisplayCodes
}) => R.allPass([
  R.always(R.complement(hasNoDisplayAnnotation)(codelist)),
  R.always(R.complement(hasNoDisplayAnnotation)(artefact)),
  R.anyPass([
    R.complement(R.has)(artefactId),
    R.hasPath([artefactId, "values"])
  ])
])(noDisplayCodes);
const getCodeLists = (pathToList) => (structure) => {
  const keyedCodelists = R.pipe(
    R.pathOr([], ["data", "codelists"]),
    R.indexBy(getUrn)
  )(structure);
  const hasNoDisplayAnnotation = (node) => R.pipe(
    R.propOr([], "annotations"),
    R.indexBy(R.prop("type")),
    R.has(NO_DISPLAY_ANNOT_TYPE)
  )(node);
  const keyedConcepts = getConcepts(structure);
  const noDisplayCodes = parseNoDisplayAnnotation(structure);
  return R.pipe(
    R.pathOr([], pathToList),
    R.addIndex(R.map)((artefact, artefactIndex) => {
      const codelist = R.pipe(
        R.path(["localRepresentation", "enumeration"]),
        R.flip(R.propOr({}))(keyedCodelists)
      )(artefact);
      const artefactId = R.prop("id", artefact);
      const values = R.pipe(
        R.propOr([], "codes"),
        R.addIndex(R.map)((code, position) => ({
          id: R.prop("id", code),
          label: R.prop("name")(code),
          description: R.prop("description", code),
          order: getCodeOrder(code),
          parentId: R.prop("parent", code),
          position,
          display: getDisplayValues({
            hasNoDisplayAnnotation,
            artefactId,
            noDisplayCodes,
            code
          })
        })),
        R.sortWith([R.ascend(R.prop("order")), R.ascend(R.prop("position"))])
      )(codelist);
      const concept = R.pipe(
        R.prop("conceptIdentity"),
        R.flip(R.propOr({}))(keyedConcepts)
      )(artefact);
      return {
        id: artefactId,
        description: R.prop("description", codelist),
        index: artefactIndex,
        role: R.pipe(R.propOr([], "conceptRoles"), R.head)(artefact),
        values,
        display: getDisplay({
          hasNoDisplayAnnotation,
          codelist,
          artefact,
          artefactId,
          noDisplayCodes
        }),
        label: R.prop("name", concept)
      };
    })
  )(structure);
};
export {
  getCodeLists as default
};
